import script from "./PandoraCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./PandoraCheckbox.vue?vue&type=style&index=0&id=13184b66&lang=css"

const __exports__ = script;

export default __exports__